<div class="topbar">
    <div class="topbar-main" style="background-color: white">
        <a href="#" id="menu-button" (click)="app.onMenuButtonClick($event)">
            <span class="pi pi-bars"></span>
        </a>
        <a href="/">
            <img style="width: auto; height: 27px" alt="main logo" [src]="app.appLogo" class="logo" />
        </a>

        <app-elastic-global-search></app-elastic-global-search>

        <div *ngIf="mobile" style="margin-left: 20px; display: inline-block"></div>

        <div class="info-icon">
            <i class="pi pi-info-circle" aria-hidden="true" pTooltip="{{globalSearchInfoTooptip}}"
                tooltipPosition="bottom"></i>
        </div>

        <div title="Notifications" class="topButton alertIcon"
            [ngClass]="{ alertIconS: app.currentUser.menuMode != 'horizontal' }" (click)="app.displayAlerts = true">
            <i class="fa fa-bell-o fa-lg" aria-hidden="true"></i>
            <span class="alertBadge">{{ app.notifications.length }}</span>
        </div>

        <div *ngIf="app?.organizationData?.isSupportTicketEnabled" class="topButton dashboardIcon" [ngClass]="{
                dashboardIconS: app.currentUser.menuMode != 'horizontal'
            }" (click)="app.onQuestionClick($event)">
            <i class="fa fa-question-circle-o fa-lg" style="font-size: 1.6em;" aria-hidden="true" pTooltip="Feedback" tooltipPosition="bottom"></i>
        </div>

        <a href="#" id="user-display" (click)="app.onTopbarMenuButtonClick($event)">
            <img alt="main logo" [src]="app.profilePic" />
        </a>

        <ul id="topbar-menu" class="fadeInDown animated" [ngClass]="{ 'topbar-menu-visible': app.topbarMenuActive }">
            <li class="search-item" *ngIf="app.user">
                <div class="username">{{ app.user.userName }}</div>
                <div class="userrole">{{ app.user.roleName }}</div>
            </li>
            <li role="menuitem">
                <a (click)="app.displayDashboard = true">
                    <i class="fa fa-fw fa-th-large"></i>
                    <span>Dashboard Widgets</span>
                </a>
            </li>
            <li role="menuitem">
                <a [routerLink]="['/']">
                    <i class="fa fa-fw fa-user"></i>
                    <span>Profile</span>
                </a>
            </li>
            <li role="menuitem">
                <a (click)="changePassword()">
                    <i class="fa fa-fw fa-user"></i>
                    <span>Change Password</span>
                </a>
            </li>
            <li role="menuitem">
                <a (click)="app.logout()">
                    <i class="fa fa-fw fa-sign-out"></i>
                    <span>Logout</span>
                </a>
            </li>
        </ul>

        <ul id="topbar-menu" class="fadeInDown animated" [ngClass]="{ 'topbar-menu-visible': app.questionMenuActive }">
            <li class="search-item">
                <div class="username"></div>
                <div class="userrole"></div>
            </li>
            <li role="menuitem" (click)="displayReportIssueForm()" class="cursor-pointer">
                <a>
                    <i class="pi pi-exclamation-triangle"></i>
                    <span>Feedback</span>
                </a>
            </li>
        </ul>
    </div>

    <app-menu></app-menu>
</div>

<p-dialog header="Change Password" *ngIf="changePasswordDisplay" [(visible)]="changePasswordDisplay" [modal]="true"
    [style]="{ width: '500px'}">
    <div class="p-grid">
        <div class="p-col-5">
            <label for="">User Name</label>
        </div>
        <div class="p-col-7">
            <label>
                {{ this.app.user.userName }}
            </label>
        </div>
    </div>
    <div class="p-grid">
        <div class="p-col-5">
            <label for="">User Email</label>
        </div>
        <div class="p-col-7">
            <label>
                {{ this.app.user.emailId }}
            </label>
        </div>
    </div>
    <div class="p-grid">
        <div class="p-col-5">
            <label for="opw">Old Password:</label>
        </div>
        <div class="p-col-7">
            <input type="password" id="opw" class="border-bottom-input" pInputText  autocomplete="new-password"
                [(ngModel)]="tempPassword.oldPassword" placeholder="Old Password" name="title" #oldPw="ngModel" />
            <small *ngIf="oldPw.touched && tempPassword.oldPassword == ''" class="error">
                Old password is required
            </small>
        </div>
    </div>
    <div class="p-grid">
        <div class="p-col-5">
            <label for="pw1">New Password:</label>
        </div>
        <div class="p-col-7">
            <input type="password" id="pw1" class="border-bottom-input" pPassword [(ngModel)]="tempPassword.newPassword"
                placeholder="New Password" name="title" #pw1="ngModel" minlength="8" required pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])(.{8,})$" />
            <div *ngIf="pw1.errors && (pw1.dirty || pw1.touched)" class="error">
                <small *ngIf="pw1.errors.required">
                    New password is required.
                </small>
                <small *ngIf="pw1.errors.minlength">
                    Password must be at least 8 characters long.
                </small>
                <small *ngIf="pw1.errors.pattern">
                    Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.
                </small>
            </div>
        </div>
    </div>
    <div class="p-grid">
        <div class="p-col-5">
            <label for="pw2">New Password Confirmation:</label>
        </div>
        <div class="p-col-7">
            <input type="password" id="pw2" class="border-bottom-input" pPassword
                [(ngModel)]="tempPassword.newPassword1" placeholder="New Password Confirmation" name="title"
                #pw2="ngModel" />
            <small *ngIf="pw2.touched && tempPassword.newPassword1 == ''" class="error">
                New password is required
            </small>
            <small *ngIf="
                    pw2.touched &&
                    tempPassword.newPassword != tempPassword.newPassword1
                " class="error">
                New password doesnt not match
            </small>
        </div>
    </div>
    <p-footer>
        <button pButton pRipple label="Save" (click)="updatePassword()"
    [disabled]="
        !tempPassword.oldPassword ||
        pw1.errors ||
        pw2.errors ||
        tempPassword.newPassword !== tempPassword.newPassword1
    " class="p-mr-2"></button>

        <button pButton pRipple label="Cancel" (click)="changePasswordDisplay = false"
            class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<!-- Report issue -->
<p-dialog header="Feedback" [modal]="true" [(visible)]="displayReportIssue" [style]="{width: '60vw'}" [closable]="false">
    <form [formGroup]="reportForm" >
        <div class="card">

        <div class="p-grid">
        </div>
        <div class="p-grid">
            <div class="p-col-12">
                <label>Please provide your feedback
                    <span style="color: red;"> * </span>
                </label>
                <textarea rows="3" cols="30" pInputTextarea formControlName="description"></textarea>
                <div *ngIf="detailsFormErrors?.description" class="p-invalid">
                    <small>{{ detailsFormErrors?.description}}</small>
                </div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12">
                <label>Attachment</label>
                <p-fileUpload   (onSelect)="onUpload($event.files)" #fileInput
                        multiple="multiple" [showUploadButton]="false" [showCancelButton]="false"  accept="image/*"   invalidFileTypeMessageDetail="Allowed file types: .png .jpg .jpeg .gif">
                        <ng-template pTemplate="file"></ng-template>
                        <ng-template pTemplate="content">
                            <ul *ngIf="uploadedFiles.length">
                                <li *ngFor="let file of uploadedFiles; let index=index;">

                                    <div class="p-fileupload-row p-mb-2">
                                        <div>
                                            <img [src]="file.content" width="50" alt="card" />
                                        </div>
                                        <div>
                                            {{file.name}}
                                        </div>
                                        <div>
                                            {{file.sizeInBytes | fileSize}}
                                        </div>
                                        <div>
                                            <button icon="pi pi-times" pButton type="button"
                                                (click)="deleteFile(uploadedFiles,index)" icon="pi pi-times"></button>
                                        </div>
                                    </div>

                                </li>

                            </ul>
                        </ng-template>
                    </p-fileUpload>
                </div>
            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
      <button pButton label="Cancel" class="p-button-secondary" (click)="closeReportIssue()"></button>
      <button pButton label="Submit" (click)="saveReportIssue()"></button>
    </ng-template>
</p-dialog>

<p-toast [baseZIndex]="999999"></p-toast>
